
export function CalcResize(lang, directon, rect, prevClient, ev) {
    let width = rect.width;
    let height = rect.height;
    let position = {x: rect.x, y: rect.y}
    // console.log(position, width, height, directon)
    // console.log(rect)
    if (lang == 'fa') {
        if (directon == 'ne') {
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height +
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right) - (prevClient.prevClientX - ev.clientX),
                y: rect.top - (prevClient.prevClientY - ev.clientY)
            }

            // console.log(width, height, position, prevClient, ev.clientX)
                    
        }
        else if(directon == 'nw'){
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height +
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right),
                y: rect.top - (prevClient.prevClientY - ev.clientY)
            }

            console.log(width, height, position, prevClient, ev.clientX)
        }
        else if(directon == 'sw'){
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right),
                y: rect.top 
            }

            // console.log(width, height, position, prevClient, ev.clientX)
        }
        else if(directon == 'se'){
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right) - (prevClient.prevClientX - ev.clientX) ,
                y: rect.top 
            }

        }
        
        else   if (directon == 'top') {
            
            height = rect.height +
                    (prevClient.prevClientY -
                        ev.clientY)
                position = {
                    x:
                    -(window.innerWidth - rect.right),
                    y: rect.top - (prevClient.prevClientY - ev.clientY)
                }
            }
            else   if (directon == 'bottom') {
                
            // width = rect.width -
            //     (prevClient.prevClientX -
            //         ev.clientX)
            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right),
                y: rect.top
            }
            
        }
            else   if (directon == 'left') {
                
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
         
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right),
                y: rect.top }
            
        }
            else   if (directon == 'right') {
                
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)
  
            position = {
                // x: rect.right - (prevClient.prevClientY - ev.clientY),
                x: -(window.innerWidth - rect.right) - (prevClient.prevClientX - ev.clientX),
                y: rect.top 
            }
            
        }


        // console.log(position)
        //         console.log(width)
        //         console.log(height)
        //         console.log(rect.left)
        // console.log(prevClient.prevClientX, ev.clientX);
        // if (directon == 'nw') {
        //     width = rect.width +
        //         (prevClient.prevClientX -
        //             ev.clientX)
        //     height = rect.height +
        //         (prevClient.prevClientY -
        //             ev.clientY)
        //     position = {
        //         x:
        //             rect.left - (prevClient.prevClientX - ev.clientX),
        //         y: rect.top - (prevClient.prevClientY - ev.clientY)
        //     }
        // }
    }
    else {
        // console.log('in english')
        if (directon == 'sw') {
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                x:
                    rect.left -
                    (prevClient.prevClientX -
                        ev.clientX),
                y: rect.top
            }
        }
        if (directon == 'se') {
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)
        }
        if (directon == 'ne') {
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height +
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                x: rect.left,
                y: rect.top - (prevClient.prevClientY - ev.clientY)
            }
        }
        if (directon == 'nw') {
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
            height = rect.height +
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                x:
                    rect.left - (prevClient.prevClientX - ev.clientX),
                y: rect.top - (prevClient.prevClientY - ev.clientY)
            }
        }
        if (directon == 'top') {

            height = rect.height +
                (prevClient.prevClientY -
                    ev.clientY)
            position = {
                x:
                    rect.left,
                y: rect.top - (prevClient.prevClientY - ev.clientY)
            }
        }
        if (directon == 'bottom') {

            height = rect.height -
                (prevClient.prevClientY -
                    ev.clientY)

        }
        if (directon == 'left') {
            width = rect.width +
                (prevClient.prevClientX -
                    ev.clientX)
            position = {
                x:
                    rect.left - (prevClient.prevClientX - ev.clientX),
                y: rect.top
            }


        }
        if (directon == 'right') {
            width = rect.width -
                (prevClient.prevClientX -
                    ev.clientX)


        }

    }
    // console.log('position in func', position)
    return { width, height, position }



}